// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__LP-W4","container":"styles_container__PI58A","title":"styles_title__1mgxU","wrapper":"styles_wrapper__2dmPm","answer":"styles_answer__Me2tH"};